<span class="d-inline-block text-truncate text-container">{{ value }}</span>
